import {MockDriftDetectionApiService, MockScpDriftApiService} from "./mock_api_repository";
import {MainDriftDetectionApiService, MainScpDriftApiService} from "./api_repository"
import {DriftDetectionApiService, ScpDriftApiService} from "./service"
import {API_MOCK_STATUS} from "../environment/environment";

export class DriftDetectionApiServiceFactory {
    static getService(): DriftDetectionApiService {
        if (API_MOCK_STATUS.isDriftDetectionMockEnabled()) {
            return new MockDriftDetectionApiService();
        } else {
            return new MainDriftDetectionApiService();
        }
    }

    static getScpDriftService(): ScpDriftApiService {
        if (API_MOCK_STATUS.isSCPMockEnabled()) {
            console.log('Using Mock SCP Drift API Service');
            return new MockScpDriftApiService();
        } else {
            console.log('Using Main SCP Drift API Service (real backend)');
            return new MainScpDriftApiService();
        }
    }
}